import { useState } from "react";
import { createPortal } from "react-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react"; // optional icons
import "../styles/image-lightbox.css"; // separate CSS file

export default function ImageLightbox({ images, initialIndex = 0, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const next = () => setCurrentIndex((i) => (i + 1) % images.length);
  const prev = () =>
    setCurrentIndex((i) => (i - 1 + images.length) % images.length);

  if (!images || images.length === 0) return null;

  return createPortal(
    <div className="lightbox-overlay">
      <button className="lightbox-close" onClick={onClose}>
        <X />
      </button>

      <button className="lightbox-prev" onClick={prev}>
        <ChevronLeft />
      </button>

      <img
        src={images[currentIndex]}
        alt={`image-${currentIndex}`}
        className="lightbox-image"
      />

      <button className="lightbox-next" onClick={next}>
        <ChevronRight />
      </button>
    </div>,
    document.body,
  );
}
